import { resolveLang, type Lang } from "../src/languages";
import { getLangPreference, setLangPreference } from "./storage";

/**
 * UI language for this page load: the player's explicit choice, else the browser's
 * preferred languages, else English. Fixed for the page's lifetime; switching reloads.
 */
export const LANG: Lang = resolveLang(
  getLangPreference(),
  navigator.languages?.length ? navigator.languages : [navigator.language],
);

/** Remembers the choice and reloads so every screen renders in the new language. */
export function switchLang(lang: Lang): void {
  if (lang === LANG) return;
  setLangPreference(lang);
  location.reload();
}
